export const logtoCookieKey = '_logto';
